document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.collapsible-header');

    headers.forEach(header => {
        header.addEventListener('click', function () {
            const content = this.nextElementSibling;
            const isExpanded = this.getAttribute('aria-expanded') === 'true';

            // Close all other sections
            headers.forEach(h => {
                if (h !== header) {
                    h.setAttribute('aria-expanded', 'false');
                    h.nextElementSibling.classList.remove('active');
                }
            });

            // Toggle current section
            this.setAttribute('aria-expanded', !isExpanded);
            content.classList.toggle('active');
        });
    });
});

